// extracted by mini-css-extract-plugin
export default {"unread":"notification_unread__S83+K","read":"notification_read__sl02Y","container":"notification_container__sRCW9"};